import React from 'react';
import { FadeUp } from '../components/AnimatedSection';
import { useLanguage } from '../context/LanguageContext';

const ContactPage = () => {
  const { language, t } = useLanguage();

  return (
    <div data-testid="contact-page" className="min-h-screen bg-black">
      <div className="container-apple section-content pt-32">
        <FadeUp>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4">
            {t('legal.contactTitle')}
          </h1>
          <p className="text-[#86868B] mb-12">{t('legal.lastUpdated')}: December 2025</p>

          <div className="space-y-8 max-w-3xl">
            <section>
              <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">
                {language === 'es' ? 'Nombre comercial' : 'Business Name'}
              </h2>
              <p className="text-[#86868B] leading-relaxed text-xl">
                Tivorao
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">
                {language === 'es' ? 'Correo electrónico' : 'Email'}
              </h2>
              <p className="text-[#86868B] leading-relaxed">
                <a 
                  href="mailto:contact.tivorao@gmail.com" 
                  className="text-[#2997FF] hover:underline text-xl"
                >
                  contact.tivorao@gmail.com
                </a>
              </p>
            </section>

            <section className="pt-8 border-t border-[#222]">
              <p className="text-[#86868B] leading-relaxed">
                {language === 'es' 
                  ? 'Para cualquier consulta sobre pedidos, devoluciones, o información sobre productos, no dudes en contactarnos. Responderemos en un plazo de 24-48 horas laborables.'
                  : 'For any questions about orders, returns, or product information, please don\'t hesitate to contact us. We will respond within 24-48 business hours.'}
              </p>
            </section>
          </div>
        </FadeUp>
      </div>
    </div>
  );
};

export default ContactPage;
